// import React, { useState, useEffect } from 'react';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import Login from './components/Login';
// import Signup from './components/Singup';
// import ForgotPassword from './components/ForgotPassword';
// import ResetPassword from './components/ResetPassword';
// import ComprehensiveDashboard from './components/ComprehensiveDashboard';
// import PortfolioDetail from './components/PortfolioDetail';
// import AdminLogin from './components/AdminLogin';
// import AdminDashboard from './components/AdminDashboard';
// import SIPDashboard from './components/SIPDashboard';
// import AuthSuccess from './components/AuthSuccess';

// import './App.css';

// function App() {
//   const [user, setUser] = useState(null);
//   const [clientData, setClientData] = useState(null);
//   const [userStatus, setUserStatus] = useState(null);
//   const [dashboardData, setDashboardData] = useState(null); // NEW: Store unified dashboard data
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Use environment variable for API URL
//   const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

//   useEffect(() => {
//     // Check if we're on reset password page first
//     const isResetPasswordPage = window.location.pathname === '/reset-password';
    
//     if (isResetPasswordPage) {
//       setIsLoading(false);
//       return;
//     }
    
//     // For all other pages, check for existing token
//     const token = localStorage.getItem('token');
//     if (token) {
//       fetchClientData(token);
//     } else {
//       setIsLoading(false);
//     }
//   }, []);

//   const checkUserStatus = async (token) => {
//     try {
//       console.log('🔍 App.js calling user-status API...');
      
//       const response = await fetch(`${API_URL}/api/user-status`, {
//         headers: { 
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         credentials: 'include'
//       });
      
//       console.log('📊 API Response status:', response.status);
      
//       if (!response.ok) {
//         throw new Error('Failed to fetch user status');
//       }
      
//       const data = await response.json();
//       console.log('✅ App.js received user status:', data);
      
//       return data;
//     } catch (error) {
//       console.error('❌ Error fetching user status:', error);
//       return null;
//     }
//   };

//   // NEW: Fetch unified dashboard data
//   const fetchDashboardData = async (token) => {
//     try {
//       console.log('📊 Fetching unified dashboard data...');
      
//       const response = await fetch(`${API_URL}/api/client/dashboard`, {
//         headers: { 
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         credentials: 'include'
//       });
      
//       if (response.ok) {
//         const data = await response.json();
//         console.log('✅ Unified dashboard data received:', data);
//         setDashboardData(data);
//         return data;
//       } else {
//         console.log('⚠️ Dashboard data fetch failed, will use legacy endpoints');
//         return null;
//       }
//     } catch (error) {
//       console.error('❌ Error fetching dashboard data:', error);
//       return null;
//     }
//   };

//   const fetchClientData = async (token) => {
//     try {
//       console.log('🚀 fetchClientData started...');
//       setIsLoading(true);
//       setError(null);
      
//       // First check user status
//       console.log('📞 About to call checkUserStatus...');
//       const userStatus = await checkUserStatus(token);
//       console.log('📊 checkUserStatus returned:', userStatus);
      
//       // Set user status for the comprehensive dashboard
//       setUserStatus(userStatus);
      
//       if (userStatus) {
//         console.log('✅ userStatus exists, stage:', userStatus.stage);
        
//         // Set user data with correct ID from userStatus
//         setUser({ 
//           name: userStatus.name || userStatus.data?.name || 'User',
//           id: userStatus.clientId
//         });
        
//         // Try to fetch unified dashboard data for all users (if KYC is completed)
//         if (userStatus.stage === 'active_investor' || userStatus.kycStatus === 'verified') {
//           console.log('🎯 User is eligible for dashboard data, fetching...');
//           const dashboardData = await fetchDashboardData(token);
          
//           if (dashboardData) {
//             // Use dashboard data to enhance client data
//             const enhancedClientData = {
//               'Id no': userStatus.clientId,
//               'Name': userStatus.name,
//               // Use dashboard summary data if available
//               initialInvestment: dashboardData.summary?.totalInvestment || 0,
//               withdrawn: dashboardData.summary?.totalWithdrawn || 0,
//               currentValue: dashboardData.summary?.currentValue || 0,
//               totalReturn: dashboardData.summary?.totalReturn || 0,
//               profitLoss: dashboardData.summary?.profitLoss || 0,
//               userType: userStatus.userType,
//               lastUpdatedDate: dashboardData.performance?.lastUpdated || new Date().toISOString(),
//               // Include original status data
//               ...userStatus.data
//             };
            
//             setClientData(enhancedClientData);
//           } else {
//             // Fallback to legacy client data fetch for active investors
//             await fetchLegacyClientData(token, userStatus);
//           }
//         } else {
//           // For users without investments (KYC pending, etc.), use basic status data
//           const basicClientData = {
//             'Id no': userStatus.clientId,
//             'Name': userStatus.name,
//             initialInvestment: 0,
//             withdrawn: 0,
//             currentValue: 0,
//             totalReturn: 0,
//             profitLoss: 0,
//             userType: userStatus.userType,
//             lastUpdatedDate: new Date().toISOString(),
//             ...userStatus.data
//           };
          
//           console.log('🔧 Setting basic clientData for non-investor:', basicClientData);
//           setClientData(basicClientData);
//         }
//       } else {
//         console.log('❌ No userStatus received, falling back to legacy');
//         await fetchLegacyClientData(token);
//       }
//     } catch (error) {
//       console.error('💥 Error in fetchClientData:', error);
//       setError(error.message);
//       localStorage.removeItem('token');
//       setUser(null);
//       setClientData(null);
//       setUserStatus(null);
//       setDashboardData(null);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Fallback to legacy client data fetching
//   const fetchLegacyClientData = async (token, userStatus = null) => {
//     try {
//       console.log('📞 Fallback: Fetching legacy client data...');
      
//       const response = await fetch(`${API_URL}/api/client`, {
//         headers: { 
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         },
//         credentials: 'include'
//       });
      
//       if (response.ok) {
//         const data = await response.json();
//         const clientName = data.Name || `${data.first_name || ''} ${data.last_name || ''}`.trim();
//         const clientId = data['Id no'] || data.client_id || userStatus?.clientId;
        
//         setUser({ 
//           name: clientName,
//           id: clientId
//         });
        
//         const formattedData = {
//           ...data,
//           'Name': clientName,
//           'Id no': clientId,
//           'lastUpdatedDate': data.lastUpdatedDate || data['Last Updated Date'] || data['Last Updated'] || data.updated_at,
//           userType: userStatus?.userType || 'active_investor'
//         };
        
//         setClientData(formattedData);
//       } else if (userStatus) {
//         // Use userStatus as fallback
//         setClientData({
//           'Id no': userStatus.clientId,
//           'Name': userStatus.name,
//           initialInvestment: 0,
//           withdrawn: 0,
//           currentValue: 0,
//           totalReturn: 0,
//           profitLoss: 0,
//           userType: userStatus.userType,
//           ...userStatus.data
//         });
//       }
//     } catch (error) {
//       console.error('❌ Error fetching legacy client data:', error);
//       if (userStatus) {
//         // Final fallback to userStatus
//         setClientData({
//           'Id no': userStatus.clientId,
//           'Name': userStatus.name,
//           initialInvestment: 0,
//           withdrawn: 0,
//           currentValue: 0,
//           totalReturn: 0,
//           profitLoss: 0,
//           userType: userStatus.userType,
//           ...userStatus.data
//         });
//       }
//     }
//   };

//   const handleLogin = (userData) => {
//     setUser(userData);
//     const token = localStorage.getItem('token');
//     if (token) {
//       fetchClientData(token);
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     setUser(null);
//     setClientData(null);
//     setUserStatus(null);
//     setDashboardData(null);
//     setError(null);
    
//     // Redirect to main website after logout
//     window.location.href = 'https://abnexus.com';
//   };

//   // Enhanced refresh function with dashboard data
//   const refreshUserData = async () => {
//     console.log('🔄 App.js refreshUserData called...');
    
//     const token = localStorage.getItem('token');
//     if (!token) {
//       console.log('❌ No token found during refresh');
//       return;
//     }

//     try {
//       setIsLoading(true);
      
//       // 1. Refresh user status
//       console.log('📞 Refreshing user status...');
//       const newUserStatus = await checkUserStatus(token);
//       console.log('✅ New user status received:', newUserStatus);
      
//       if (newUserStatus) {
//         // 2. Update userStatus state immediately
//         setUserStatus(newUserStatus);
        
//         // 3. Update user data
//         setUser({ 
//           name: newUserStatus.name || newUserStatus.data?.name || 'User',
//           id: newUserStatus.clientId
//         });
        
//         // 4. Refresh dashboard data if eligible
//         if (newUserStatus.stage === 'active_investor' || newUserStatus.kycStatus === 'verified') {
//           console.log('🎯 Refreshing dashboard data...');
//           const newDashboardData = await fetchDashboardData(token);
          
//           if (newDashboardData) {
//             // Update client data with fresh dashboard data
//             const enhancedClientData = {
//               'Id no': newUserStatus.clientId,
//               'Name': newUserStatus.name,
//               initialInvestment: newDashboardData.summary?.totalInvestment || 0,
//               withdrawn: newDashboardData.summary?.totalWithdrawn || 0,
//               currentValue: newDashboardData.summary?.currentValue || 0,
//               totalReturn: newDashboardData.summary?.totalReturn || 0,
//               profitLoss: newDashboardData.summary?.profitLoss || 0,
//               userType: newUserStatus.userType,
//               lastUpdatedDate: newDashboardData.performance?.lastUpdated || new Date().toISOString(),
//               ...newUserStatus.data
//             };
            
//             setClientData(enhancedClientData);
//           } else {
//             // Fallback to legacy refresh
//             await fetchLegacyClientData(token, newUserStatus);
//           }
//         } else {
//           // For non-investors, use basic data
//           setClientData({
//             'Id no': newUserStatus.clientId,
//             'Name': newUserStatus.name,
//             initialInvestment: 0,
//             withdrawn: 0,
//             currentValue: 0,
//             totalReturn: 0,
//             profitLoss: 0,
//             userType: newUserStatus.userType,
//             lastUpdatedDate: new Date().toISOString(),
//             ...newUserStatus.data
//           });
//         }
        
//         console.log('✅ App.js refresh completed successfully');
//       } else {
//         console.log('❌ No user status received during refresh');
//       }
//     } catch (error) {
//       console.error('❌ Error in refreshUserData:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Debug version for testing
//   const debugRefreshUserData = async () => {
//     console.log('🔍 DEBUG: refreshUserData called');
//     console.log('🔍 Current userStatus before refresh:', userStatus);
//     console.log('🔍 Current dashboardData before refresh:', dashboardData);
    
//     await refreshUserData();
    
//     // Check states after a small delay to ensure updates
//     setTimeout(() => {
//       console.log('🔍 Current userStatus after refresh:', userStatus);
//       console.log('🔍 Current dashboardData after refresh:', dashboardData);
//     }, 100);
//   };

//   // Don't show loading screen if we're on the reset password page
//   const isResetPasswordPage = window.location.pathname === '/reset-password';
  
//   if (isLoading && !isResetPasswordPage) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A]">
//         <div className="text-center">
//           <div className="w-16 h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
//             <div className="w-8 h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
//           </div>
//           <div className="text-lg font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
//             Loading your dashboard...
//           </div>
//           <div className="text-sm text-[#B8B8B8]" style={{fontFamily: 'Lexend, sans-serif'}}>
//             Fetching your investment data
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <BrowserRouter>
//       <div className="App">
//         {error && (
//           <div className="fixed top-0 left-0 right-0 bg-red-500/90 backdrop-blur text-white p-4 text-center z-50 border-b border-red-400">
//             <div className="max-w-4xl mx-auto flex items-center justify-between">
//               <div className="flex items-center space-x-3">
//                 <div className="w-5 h-5 bg-white/20 rounded-full flex items-center justify-center">
//                   <span className="text-xs font-bold">!</span>
//                 </div>
//                 <span className="font-medium">{error}</span>
//               </div>
//               <button 
//                 onClick={() => setError(null)} 
//                 className="px-3 py-1 bg-white/20 rounded-lg hover:bg-white/30 transition-colors text-sm font-medium"
//               >
//                 Dismiss
//               </button>
//             </div>
//           </div>
//         )}
        
//         <Routes>
//           <Route 
//             path="/" 
//             element={user ? <Navigate to="/dashboard" replace /> : <Login onLogin={handleLogin} />} 
//           />
//           <Route 
//             path="/login" 
//             element={user ? <Navigate to="/dashboard" replace /> : <Login onLogin={handleLogin} />} 
//           />
//           <Route 
//             path="/signup" 
//             element={user ? <Navigate to="/dashboard" replace /> : <Signup />} 
//           />
//           <Route path="/forgot-password" element={<ForgotPassword />} />
//           <Route path="/reset-password" element={<ResetPassword />} />
//           <Route path="/auth/success" element={<AuthSuccess onLogin={handleLogin} />} />
          
//           {/* ENHANCED DASHBOARD ROUTE - Now with unified dashboard data */}
// // Replace your dashboard route with this:
// <Route
//   path="/dashboard"
//   element={
//     !user ? (
//       <Navigate to="/login" replace />
//     ) : isLoading ? (
//       <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A]">
//         <div className="text-center">
//           <div className="w-16 h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
//             <div className="w-8 h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
//           </div>
//           <div className="text-lg font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
//             Loading your dashboard...
//           </div>
//           <div className="text-sm text-[#B8B8B8]" style={{fontFamily: 'Lexend, sans-serif'}}>
//             Setting up your personalized experience
//           </div>
//         </div>
//       </div>
//     ) : (
//       <ComprehensiveDashboard 
//         client={clientData} 
//         userStatus={userStatus}
//         dashboardData={dashboardData}
//         onLogout={handleLogout}
//         onStatusUpdate={refreshUserData}
//       />
//     )
//   }
// />

// // Also update your portfolio route the same way:
// <Route
//   path="/portfolio/:portfolioName"
//   element={
//     !user ? (
//       <Navigate to="/login" replace />
//     ) : isLoading ? (
//       <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A]">
//         <div className="text-center">
//           <div className="w-16 h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
//             <div className="w-8 h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
//           </div>
//           <div className="text-lg font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
//             Loading portfolio data...
//           </div>
//         </div>
//       </div>
//     ) : (
//       <PortfolioDetail 
//         client={clientData} 
//         onLogout={handleLogout}
//         dashboardData={dashboardData}
//       />
//     )
//   }
// />
          
//           {/* Admin routes remain unchanged */}
//           <Route 
//             path="/admin"
//             element={<AdminDashboard />} 
//           />
//           <Route 
//             path="/admin/login" 
//             element={<AdminLogin />}
//           />
//         </Routes>
//       </div>
//     </BrowserRouter>
//   );
// }

// export default App;

import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import Signup from './components/Singup';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import ComprehensiveDashboard from './components/ComprehensiveDashboard';
import { PortfolioDetail } from './components/PortfolioOverview';
import AdminLogin from './components/AdminLogin';
import AdminForgotPassword from './components/AdminForgotPassword';
import AdminDashboard from './components/AdminDashboard';
import AdminViewAsUser from './components/AdminViewAsUser';
import AuthSuccess from './components/AuthSuccess';
import PublicStrategies from './components/PublicStrategies';
import { useTheme } from './theme/ThemeContext';

import './App.css';

function App() {
  const { theme } = useTheme();
  const [user, setUser] = useState(null);
  const [clientData, setClientData] = useState(null);
  const [userStatus, setUserStatus] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Use environment variable for API URL
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    // Check if we're on reset password page first
    const isResetPasswordPage = window.location.pathname === '/reset-password';
    
    if (isResetPasswordPage) {
      setIsLoading(false);
      return;
    }
    
    // For all other pages, check for existing token
    const token = localStorage.getItem('token');
    if (token) {
      fetchClientData(token);
    } else {
      setIsLoading(false);
    }
  }, []);

  const checkUserStatus = async (token) => {
    try {
      console.log('🔍 App.js calling user-status API...');
      
      const response = await fetch(`${API_URL}/api/user-status`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      
      console.log('📊 API Response status:', response.status);
      
      if (!response.ok) {
        throw new Error('Failed to fetch user status');
      }
      
      const data = await response.json();
      console.log('✅ App.js received user status:', data);
      
      return data;
    } catch (error) {
      console.error('❌ Error fetching user status:', error);
      
      return null;
    }
  };

  // NEW: Fetch unified dashboard data
  const fetchDashboardData = async (token) => {
    try {
      console.log('📊 Fetching unified dashboard data...');
      
      const response = await fetch(`${API_URL}/api/client/dashboard`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✅ Unified dashboard data received:', data);
        setDashboardData(data);
        return data;
      } else {
        console.log('⚠️ Dashboard data fetch failed, will use legacy endpoints');
        return null;
      }
    } catch (error) {
      console.error('❌ Error fetching dashboard data:', error);
      
      return null;
    }
  };

  const fetchClientData = async (token) => {
    try {
      console.log('🚀 fetchClientData started...');
      setIsLoading(true);
      setError(null);
      
      // First check user status
      console.log('📞 About to call checkUserStatus...');
      const userStatus = await checkUserStatus(token);
      console.log('📊 checkUserStatus returned:', userStatus);
      
      // Set user status for the comprehensive dashboard
      setUserStatus(userStatus);
      
      if (userStatus) {
        console.log('✅ userStatus exists, stage:', userStatus.stage);
        
        // Set user data with correct ID from userStatus
        setUser({ 
          name: userStatus.name || userStatus.data?.name || 'User',
          id: userStatus.clientId
        });
        
        // Try to fetch unified dashboard data for all users (if KYC is completed)
        if (userStatus.stage === 'active_investor' || userStatus.kycStatus === 'verified') {
          console.log('🎯 User is eligible for dashboard data, fetching...');
          const dashboardData = await fetchDashboardData(token);
          
          if (dashboardData) {
            // Use dashboard data to enhance client data
            const enhancedClientData = {
              'Id no': userStatus.clientId,
              'Name': userStatus.name,
              // Use dashboard summary data if available
              initialInvestment: dashboardData.summary?.totalInvestment || 0,
              withdrawn: dashboardData.summary?.totalWithdrawn || 0,
              currentValue: dashboardData.summary?.currentValue || 0,
              totalReturn: dashboardData.summary?.totalReturn || 0,
              profitLoss: dashboardData.summary?.profitLoss || 0,
              userType: userStatus.userType,
              lastUpdatedDate: dashboardData.performance?.lastUpdated || new Date().toISOString(),
              // Include original status data
              ...userStatus.data
            };
            
            setClientData(enhancedClientData);
          } else {
            // Fallback to legacy client data fetch for active investors
            await fetchLegacyClientData(token, userStatus);
          }
        } else {
          // For users without investments (KYC pending, etc.), use basic status data
          const basicClientData = {
            'Id no': userStatus.clientId,
            'Name': userStatus.name,
            initialInvestment: 0,
            withdrawn: 0,
            currentValue: 0,
            totalReturn: 0,
            profitLoss: 0,
            userType: userStatus.userType,
            lastUpdatedDate: new Date().toISOString(),
            ...userStatus.data
          };
          
          console.log('🔧 Setting basic clientData for non-investor:', basicClientData);
          setClientData(basicClientData);
        }
      } else {
        console.log('❌ No userStatus received, falling back to legacy');
        await fetchLegacyClientData(token);
      }
    } catch (error) {
      console.error('💥 Error in fetchClientData:', error);
      setError(error.message);
      
      localStorage.removeItem('token');
      setUser(null);
      setClientData(null);
      setUserStatus(null);
      setDashboardData(null);
    } finally {
      setIsLoading(false);
    }
  };

  // Fallback to legacy client data fetching
  const fetchLegacyClientData = async (token, userStatus = null) => {
    try {
      console.log('📞 Fallback: Fetching legacy client data...');
      
      const response = await fetch(`${API_URL}/api/client`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        const clientName = data.Name || `${data.first_name || ''} ${data.last_name || ''}`.trim();
        const clientId = data['Id no'] || data.client_id || userStatus?.clientId;
        
        setUser({ 
          name: clientName,
          id: clientId
        });
        
        const formattedData = {
          ...data,
          'Name': clientName,
          'Id no': clientId,
          'lastUpdatedDate': data.lastUpdatedDate || data['Last Updated Date'] || data['Last Updated'] || data.updated_at,
          userType: userStatus?.userType || 'active_investor'
        };
        
        setClientData(formattedData);
      } else if (userStatus) {
        // Use userStatus as fallback
        setClientData({
          'Id no': userStatus.clientId,
          'Name': userStatus.name,
          initialInvestment: 0,
          withdrawn: 0,
          currentValue: 0,
          totalReturn: 0,
          profitLoss: 0,
          userType: userStatus.userType,
          ...userStatus.data
        });
      }
    } catch (error) {
      console.error('❌ Error fetching legacy client data:', error);
      
      if (userStatus) {
        // Final fallback to userStatus
        setClientData({
          'Id no': userStatus.clientId,
          'Name': userStatus.name,
          initialInvestment: 0,
          withdrawn: 0,
          currentValue: 0,
          totalReturn: 0,
          profitLoss: 0,
          userType: userStatus.userType,
          ...userStatus.data
        });
      }
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
    
    const token = localStorage.getItem('token');
    if (token) {
      fetchClientData(token);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setClientData(null);
    setUserStatus(null);
    setDashboardData(null);
    setError(null);
    
    // Redirect to main website after logout
    window.location.href = 'https://abnexus.com';
  };

  // Enhanced refresh function with dashboard data
  const refreshUserData = async () => {
    console.log('🔄 App.js refreshUserData called...');
    
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('❌ No token found during refresh');
      return;
    }

    try {
      setIsLoading(true);
      
      // 1. Refresh user status
      console.log('📞 Refreshing user status...');
      const newUserStatus = await checkUserStatus(token);
      console.log('✅ New user status received:', newUserStatus);
      
      if (newUserStatus) {
        // 2. Update userStatus state immediately
        setUserStatus(newUserStatus);
        
        // 3. Update user data
        setUser({ 
          name: newUserStatus.name || newUserStatus.data?.name || 'User',
          id: newUserStatus.clientId
        });
        
        // 4. Refresh dashboard data if eligible
        if (newUserStatus.stage === 'active_investor' || newUserStatus.kycStatus === 'verified') {
          console.log('🎯 Refreshing dashboard data...');
          const newDashboardData = await fetchDashboardData(token);
          
          if (newDashboardData) {
            // Update client data with fresh dashboard data
            const enhancedClientData = {
              'Id no': newUserStatus.clientId,
              'Name': newUserStatus.name,
              initialInvestment: newDashboardData.summary?.totalInvestment || 0,
              withdrawn: newDashboardData.summary?.totalWithdrawn || 0,
              currentValue: newDashboardData.summary?.currentValue || 0,
              totalReturn: newDashboardData.summary?.totalReturn || 0,
              profitLoss: newDashboardData.summary?.profitLoss || 0,
              userType: newUserStatus.userType,
              lastUpdatedDate: newDashboardData.performance?.lastUpdated || new Date().toISOString(),
              ...newUserStatus.data
            };
            
            setClientData(enhancedClientData);
          } else {
            // Fallback to legacy refresh
            await fetchLegacyClientData(token, newUserStatus);
          }
        } else {
          // For non-investors, use basic data
          setClientData({
            'Id no': newUserStatus.clientId,
            'Name': newUserStatus.name,
            initialInvestment: 0,
            withdrawn: 0,
            currentValue: 0,
            totalReturn: 0,
            profitLoss: 0,
            userType: newUserStatus.userType,
            lastUpdatedDate: new Date().toISOString(),
            ...newUserStatus.data
          });
        }
        
        console.log('✅ App.js refresh completed successfully');
      } else {
        console.log('❌ No user status received during refresh');
      }
    } catch (error) {
      console.error('❌ Error in refreshUserData:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Don't show loading screen if we're on the reset password page
  const isResetPasswordPage = window.location.pathname === '/reset-password';
  
  if (isLoading && !isResetPasswordPage) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A]">
        <div className="text-center">
          <div className="w-16 h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <div className="w-8 h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
          </div>
          <div className="text-lg font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
            Loading your dashboard...
          </div>
          <div className="text-sm text-[#B8B8B8]" style={{fontFamily: 'Lexend, sans-serif'}}>
            Fetching your investment data
          </div>
        </div>
      </div>
    );
  }

  const ProtectedDashboard = ComprehensiveDashboard;
  const ProtectedPortfolioDetail = PortfolioDetail;

  function AdminProtected({ render }) {
    const navigate = useNavigate();
    if (!localStorage.getItem('adminToken')) {
      return <Navigate to="/admin/login" replace />;
    }
    const handleAdminLogout = () => {
      localStorage.removeItem('adminToken');
      navigate('/admin/login', { replace: true });
    };
    return render(handleAdminLogout, navigate);
  }

  return (
    <BrowserRouter>
      <div className="App" data-theme={theme}>
        {error && (
          <div className="fixed top-0 left-0 right-0 bg-red-500/90 backdrop-blur text-white p-4 text-center z-50 border-b border-red-400">
            <div className="max-w-4xl mx-auto flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 bg-white/20 rounded-full flex items-center justify-center">
                  <span className="text-xs font-bold">!</span>
                </div>
                <span className="font-medium">{error}</span>
              </div>
              <button 
                onClick={() => setError(null)} 
                className="px-3 py-1 bg-white/20 rounded-lg hover:bg-white/30 transition-colors text-sm font-medium"
              >
                Dismiss
              </button>
            </div>
          </div>
        )}
        
        <Routes>
          <Route 
            path="/" 
            element={
              user 
                ? <Navigate to="/dashboard" replace /> 
                : <PublicStrategies />
            } 
          />
          <Route 
            path="/login" 
            element={user ? <Navigate to="/dashboard" replace /> : <Login onLogin={handleLogin} />} 
          />
          <Route 
            path="/signup" 
            element={user ? <Navigate to="/dashboard" replace /> : <Signup />} 
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/auth/success" element={<AuthSuccess onLogin={handleLogin} />} />
          <Route 
            path="/investment-strategies" 
            element={
              <PublicStrategies />
            } 
          />
          
          {/* ENHANCED DASHBOARD ROUTE - Now with unified dashboard data */}
          {/* <Route
            path="/dashboard"
            element={
              !user ? (
                <Navigate to="/login" replace />
              ) : isLoading ? (
                <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A]">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                      <div className="w-8 h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
                    </div>
                    <div className="text-lg font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                      Loading your dashboard...
                    </div>
                    <div className="text-sm text-[#B8B8B8]" style={{fontFamily: 'Lexend, sans-serif'}}>
                      Setting up your personalized experience
                    </div>
                  </div>
                </div>
              ) : (
                <ProtectedDashboard 
                  client={clientData} 
                  userStatus={userStatus}
                  dashboardData={dashboardData}
                  onLogout={handleLogout}
                  onStatusUpdate={refreshUserData}
                />
              )
            }
          /> */}

          <Route
  path="/dashboard"
  element={
    !user ? (
      <Navigate to="/login" replace />
    ) : (
      <ProtectedDashboard 
        client={clientData} 
        userStatus={userStatus}
        dashboardData={dashboardData}
        onLogout={handleLogout}
        onStatusUpdate={refreshUserData}
      />
    )
  }
/>

          {/* Also update your portfolio route the same way */}
          <Route
            path="/portfolio/:portfolioName"
            element={
              !user ? (
                <Navigate to="/login" replace />
              ) : isLoading ? (
                <div className="flex items-center justify-center min-h-screen bg-[#0A0A0A]">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-[#676DFF]/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                      <div className="w-8 h-8 border-2 border-[#676DFF] border-t-transparent rounded-full animate-spin"></div>
                    </div>
                    <div className="text-lg font-medium text-white mb-2" style={{fontFamily: 'Lexend, sans-serif'}}>
                      Loading portfolio data...
                    </div>
                  </div>
                </div>
              ) : (
                <ProtectedPortfolioDetail 
                  client={clientData} 
                  onLogout={handleLogout}
                  dashboardData={dashboardData}
                />
              )
            }
          />
          
          {/* Admin routes: gate by adminToken, support preview */}
          <Route
            path="/admin"
            element={
              <AdminProtected
                render={(onLogout) => <AdminDashboard onLogout={onLogout} />}
              />
            }
          />
          <Route
            path="/admin/preview/:clientId"
            element={
              <AdminProtected
                render={(onLogout, navigate) => (
                  <AdminViewAsUser onBack={() => navigate('/admin')} />
                )}
              />
            }
          />
          <Route
            path="/admin/login"
            element={<AdminLogin />}
          />
          <Route
            path="/admin/forgot-password"
            element={<AdminForgotPassword />}
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;